import * as React from 'react';
import { DifferenceModal } from '@cian/frontend-newbuilding-sellers-info-components';
import { ActionLink, Link, UIText1 } from '@cian/ui-kit';

import { IconFunctionalInformation16 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './styles.css';

interface IOffersFooterProps {
  fromAgentsPropsCountDisplay: string;
  fromAgentsPropsCountUrl: string;
  propsCountDisplay: string;
  propsCountUrl: string;
  isHouseSelected: boolean;
  onAgentOffersLinkClick(): void;
  onAllOffersLinkClick(): void;
  onSellersInfoClick(): void;
}

export function OffersFooter({
  fromAgentsPropsCountDisplay,
  fromAgentsPropsCountUrl,
  propsCountDisplay,
  propsCountUrl,
  isHouseSelected,
  onAgentOffersLinkClick,
  onAllOffersLinkClick,
  onSellersInfoClick,
}: IOffersFooterProps) {
  const [isOpen, setIsOpen] = React.useState(false);

  const onClickActionLink = React.useCallback(() => {
    setIsOpen(true);
    onSellersInfoClick();
  }, [onSellersInfoClick]);
  const onClose = React.useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <>
      <div className={styles['container']}>
        {fromAgentsPropsCountDisplay && (
          <div className={styles['link']}>
            <UIText1>
              Ещё{' '}
              <Link href={fromAgentsPropsCountUrl} target="blank" onClick={onAgentOffersLinkClick}>
                {fromAgentsPropsCountDisplay}
              </Link>{' '}
              продают{' '}
              <ActionLink onClick={onClickActionLink} inline>
                агенты и собственники
              </ActionLink>
            </UIText1>
            <span className={styles['icon']} onClick={onClickActionLink}>
              <IconFunctionalInformation16 color="icon-main-default" />
            </span>
          </div>
        )}
        <div className={styles['count']}>
          <UIText1>
            Всего{' '}
            <Link href={propsCountUrl} target="blank" data-testid="AllOffersLink" onClick={onAllOffersLinkClick}>
              {propsCountDisplay}
            </Link>
            {isHouseSelected ? ' в этом корпусе' : ' в ЖК'}
          </UIText1>
        </div>
      </div>
      <DifferenceModal open={isOpen} onClose={onClose} />
    </>
  );
}
